import type { ButtonProps } from '@mui/material';
import { Button } from '@mui/material';
import type { ButtonTypeMap } from '@mui/material/Button/Button';
import React from 'react';

export function CtaButton<
  RootComponent extends React.ElementType = ButtonTypeMap['defaultComponent'],
  AdditionalProps = {},
>(props: ButtonProps<RootComponent, AdditionalProps>) {
  return (
    <Button
      variant="contained"
      size="large"
      {...props}
    />
  );
}